'use client';

import { useLayoutEffect, useState } from 'react';

import type { WindowSize } from '../types';

/**
 * TODO: replace with useWindowWidth from /common-next
 */
export function useWindowSize() {
    const [windowSize, setWindowSize] = useState<WindowSize>({ width: 0 });

    const handleSize = () => {
        setWindowSize({
            width: window.innerWidth,
        });
    };

    useLayoutEffect(() => {
        handleSize();

        window.addEventListener('resize', handleSize);

        return () => window.removeEventListener('resize', handleSize);
    }, []);

    return windowSize.width;
}
